import { actions } from './nurceOfficePhy/actions'
import { getters } from './nurceOfficePhy/getters'
import { state } from './nurceOfficePhy/state'
import { mutations } from './nurceOfficePhy/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
